import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SafeArea',
  props: {
    position: {
        type: String as PropType<"top" | "bottom">,
        required: false,
        default: "top"
    }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["safe-area-background w-full lg:w-0", __props.position])
  }, null, 2))
}
}

})